/** @jsxImportSource theme-ui */
import React from "react";
import { useThemeUI } from "theme-ui";
import { motion } from "framer-motion";
import { useSelector, useDispatch } from "react-redux";
import { selectHasAllRequiredValues } from "store/app";

import * as styles from "./ProductV2.styles";
import { Button } from "components";
import { ArrowRightIcon } from "components/icons";
import { useTranslation } from "hooks";
import {
  setCustomisationStage,
  setShowReviewOrderPage,
} from "store/app/appSlice";

export default function ReviewOrderButton() {
  const { t } = useTranslation();

  const {
    theme: { isMobile },
  } = useThemeUI();

  const hasAllRequiredValues = useSelector(selectHasAllRequiredValues);

  const dispatch = useDispatch();

  const dispatchSetCustomisationStage = (stage) => {
    dispatch(setCustomisationStage(stage));
  };

  const handleClick = () => {
    dispatch(setShowReviewOrderPage(true));
    dispatchSetCustomisationStage(3);
  };

  return (
    <motion.div
      sx={styles.reviewOrderButtonContainer}
      initial={{
        opacity: 0,
        x: "100%",
      }}
      animate={{
        x: "0%",
        opacity: 1,
        transition: {
          duration: 0.3,
        },
      }}
    >
      <Button
        isRound
        iconAfter={<ArrowRightIcon />}
        size="large"
        onClick={handleClick}
        disabled={!hasAllRequiredValues}
        sx={styles.reviewOrderButton}
      >
        {isMobile ? "" : t("Review")}
      </Button>
    </motion.div>
  );
}
